import LiveKitVideoRoomContainer from './livekit';
import TwilioVideoRoomContainer from './twilio';

import ErrorComponent from '../../components/Error';
import TelemedicineContext from '../../context/telemedicine';
import { LIVEKIT_PROVIDER } from '../../utils/telemedicine';

import { useContext } from 'react';

const VideoRoom = () => {
	const { telemedicine } = useContext(TelemedicineContext);

	if (telemedicine?.provider === LIVEKIT_PROVIDER) {
		return telemedicine.livekit
			? <LiveKitVideoRoomContainer />
			: <ErrorComponent message="Não foi possível entrar na chamada." />;
	}

	return <TwilioVideoRoomContainer />;
};

export default VideoRoom;
